import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ThankYou() {
  const pad = "clamp(20px, 5vw, 80px)";

  useEffect(() => {
    document.title = "Thank You | Truestays";
    window.scrollTo(0, 0);
  }, []);

  return (
    <section style={{ backgroundColor: "#FFFFFF", paddingTop: "clamp(120px, 12vw, 180px)", paddingBottom: "clamp(80px, 10vw, 130px)", paddingLeft: pad, paddingRight: pad, minHeight: "100vh" }}>
      <div style={{ maxWidth: 560, margin: "0 auto", textAlign: "center" }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#888", marginBottom: 12, marginTop: 0 }}>Thank you</p>
        <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 800, fontSize: "clamp(28px, 4vw, 44px)", color: "#1A1A1A", lineHeight: 1.15, marginBottom: 12, marginTop: 0 }}>We'll be in touch</h1>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#555", lineHeight: 1.65, marginBottom: 40 }}>
          Thanks for your enquiry. One of our team will be in touch within 24 hours with your personalised income estimate.
        </p>

        <button
          onClick={() => {
            if (window.history.length > 1) {
              window.history.back();
            } else {
              window.location.href = "/";
            }
          }}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "14px 28px",
            background: "#112215",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 15,
            fontWeight: 600,
            cursor: "pointer",
            transition: "background 0.15s",
            marginBottom: 24,
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#333"}
          onMouseLeave={e => e.currentTarget.style.background = "#112215"}
        >
          <ArrowLeft size={16} />
          Return to previous page
        </button>

        <div>
          <Link to="/" style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#888", textDecoration: "underline" }}>Back to homepage</Link>
        </div>
      </div>
    </section>
  );
}